import { render, staticRenderFns } from "./AttributeColor.vue?vue&type=template&id=0430eeaa&scoped=true&"
import script from "./AttributeColor.vue?vue&type=script&lang=js&"
export * from "./AttributeColor.vue?vue&type=script&lang=js&"
import style0 from "./AttributeColor.vue?vue&type=style&index=0&id=0430eeaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0430eeaa",
  null
  
)

export default component.exports